import { ESignPreferenceEditForm } from 'application/esign-preference/forms';
import { BaseEditViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { ESignPreferenceService } from 'application/esign-preference/services';
import { action } from 'mobx';

@applicationContext
class ESignPreferenceEditViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new ESignPreferenceService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'esign-preference-edit',
            id: id,
            Form: ESignPreferenceEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: ESignPreferenceEditForm,
        });
    }

    onCreateError(err) {
        if (!this.errorActions.onCreateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This E-Sign Preference already exists.' : err.data.message : `Error occurred while trying to update a E-Sign Preference.`
            );
            return;
        }
        return this.errorActions.onCreateError(err)
    }

    onUpdateError(err) {
        if (!this.errorActions.onUpdateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This E-Sign Preference already exists.' : err.data.message : `Error occurred while trying to update a E-Sign Preference.`
            );
            return;
        }
        return this.errorActions.onUpdateError(err);
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('ESIGN_PREFERENCE.CREATE.SUCCESS_CREATE');
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('ESIGN_PREFERENCE.EDIT.SUCCESS_UPDATE', name);
    }
}

export default ESignPreferenceEditViewStore;
